module.exports = __webpack_public_path__ + "static/media/6.89a6bde8.JPG";